import React from 'react';
import './Registry.css';

const Registry: React.FC = () => {
  const registryLinks = [
    {
      title: 'Save the Children',
      description: 'Supporting education for underprivileged children',
      url: 'https://support.savethechildren.org/site/TR/Endurance/General?pg=personal&px=8822344&fr_id=1461',
      icon: '📚',
      badge: 'Charity Option'
    },
    {
      title: 'Special Olympics',
      description: 'Supporting athletes with intellectual disabilities',
      url: 'https://fundraise.specialolympics.org/fundraiser/6829948',
      icon: '🏅',
      badge: 'Charity Option'
    },
    {
      title: 'Registry & Sabbatical Year',
      description: 'Our wedding registry and sabbatical year fund',
      subDescription: "(If you didn't know, Lance & Morgan plan to take a year to travel between Morgan's residency and fellowship!)",
      url: 'https://www.zola.com/registry/lanceandmorgan2026',
      icon: '🎁',
      badge: '\u00A0' // Non-breaking space for alignment
    }
  ];

  const handleClick = (url: string, e: React.MouseEvent) => {
    if (url === '#') {
      e.preventDefault();
    }
  };

  return (
    <section className="registry-section pt-0 pb-5">
      <div className="container">
        <div className="row">
          <div className="col-12 mb-5">
            <h2 className="title-text mb-4">Registry & Gifts</h2>
            <p className="content-text mb-3">
              Your presence at our wedding is honestly more than enough - no gifts necessary.
            </p>
            <p className="content-text mb-3">
              We feel incredibly lucky to have the lives we have with so many incredible people in them, and would love to use this opportunity to give back. That said, we do have a small registry and sabbatical year fund available as well.
            </p>
            <p className="content-text">
              If you wish to honor us with a gift, we've provided some options below.
            </p>
          </div>
        </div>

        <div className="row justify-content-center">
          {registryLinks.map((link, index) => (
            <div key={index} className="col-md-4 mb-4">
              <a
                href={link.url}
                target="_blank"
                rel="noopener noreferrer"
                className="registry-card"
                onClick={(e) => handleClick(link.url, e)}
              >
                {link.badge && <div className={`registry-card-badge ${link.badge.trim() === '' ? 'registry-card-badge-empty' : ''}`}>{link.badge}</div>}
                <div className="registry-card-icon">{link.icon}</div>
                <h3 className="registry-card-title">{link.title}</h3>
                <p className="registry-card-description">{link.description}</p>
                {link.subDescription && <p className="registry-card-subdescription">{link.subDescription}</p>}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Registry;
